import _regeneratorRuntime from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { tryCatch } from 'fp-ts/lib/TaskEither';
import { Left, Right } from 'fp-ts/lib/Either';
import { curry } from 'fp-ts/lib/function';
import { PathReporter } from 'io-ts/lib/PathReporter';
import { instantiateLogger } from '../logging';
var logger = instantiateLogger('heimdall:core:core-common:utils:tasks');
export function taskEitherWrapper(f) {
  return tryCatch(
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", f());

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), function (reason) {
    if (reason instanceof Error) {
      return reason;
    } else {
      return new Error(String(reason));
    }
  });
}
export function executeAndDecodeFunction(_x, _x2) {
  return _executeAndDecodeFunction.apply(this, arguments);
}

function _executeAndDecodeFunction() {
  _executeAndDecodeFunction = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(validator, task) {
    var log, taskResult, v, validationResult;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            log = logger.extend('executeAndValidate');
            _context2.next = 3;
            return task.run();

          case 3:
            taskResult = _context2.sent;
            v = taskResult.value;
            log("Task Result: ".concat(JSON.stringify(v)));

            if (!(validator.is(v) && !(v instanceof Error))) {
              _context2.next = 10;
              break;
            }

            validationResult = validator.decode(v);
            log("Validation Result: ".concat(JSON.stringify(validationResult.value)));
            return _context2.abrupt("return", validationResult.fold(function (_) {
              var messages = PathReporter.report(validationResult);
              return new Left(new Error(messages + '\n'));
            }, function (value) {
              return new Right(value);
            }));

          case 10:
            return _context2.abrupt("return", taskResult.fold(function (err) {
              return new Left(err);
            }, function (u) {
              return new Left(new Error("Invalid data returned: ".concat(JSON.stringify(u))));
            }));

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _executeAndDecodeFunction.apply(this, arguments);
}

export function executeAndDecodeListFunction(_x3, _x4) {
  return _executeAndDecodeListFunction.apply(this, arguments);
}

function _executeAndDecodeListFunction() {
  _executeAndDecodeListFunction = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(validator, task) {
    var log, taskResult, v;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            log = logger.extend('executeAndValidate');
            _context3.next = 3;
            return task.run();

          case 3:
            taskResult = _context3.sent;
            v = taskResult.value;
            log("Task Result: ".concat(JSON.stringify(v)));

            if (v instanceof Error) {
              _context3.next = 8;
              break;
            }

            return _context3.abrupt("return", v.map(function (ele) {
              var validationResult = validator.decode(ele);
              log("Validation Result: ".concat(JSON.stringify(validationResult.value)));
              return validationResult.fold(function (_) {
                var messages = PathReporter.report(validationResult);
                return new Left(new Error(messages + '\n'));
              }, function (value) {
                return new Right(value);
              });
            }));

          case 8:
            return _context3.abrupt("return", taskResult.fold(function (err) {
              return [new Left(err)];
            }, function (u) {
              return [new Left(new Error("Invalid data returned: ".concat(JSON.stringify(u))))];
            }));

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _executeAndDecodeListFunction.apply(this, arguments);
}

export var executeAndDecode = curry(executeAndDecodeFunction);
export var executeAndDecodeList = curry(executeAndDecodeListFunction);